import React from 'react';
import { Link } from 'gatsby';
import { Container, Icon, Paper, useWindowSize } from 'library';

import './TwoHomeownerQuotesBlock.scss';

const TwoHomeownerQuotesBlock = ({ title, quotes }) => {
  const { isScreenSize } = useWindowSize();

  return (
    <Paper pad={isScreenSize('sm') ? { top: 7, bottom: 7 } : 7}>
      {title && <h2 className="TwoHomeownerQuotesBlockHeader">{title}</h2>}
      <Container row justify="center">
        {quotes?.slice(0, 2).map((data, key) => {
          const homeowner = data?.homeownerStoryFields;
          if (!homeowner) {
            return null;
          }

          return (
            <Container grid="5" respondAt="md" key={key}>
              <div className="TwoHomeownerQuotesBlockCard">
                <div className="TwoHomeownerQuotesBlockProfile">
                  <div className="TwoHomeownerQuotesBlockContent">
                    <h4>
                      <span className="HomeownerName">{homeowner.homeownerName}</span>
                      <br />
                      <span className="HomeownerLocation">
                        {homeowner.city}, {homeowner.state}
                      </span>
                    </h4>
                  </div>
                </div>
                <blockquote>
                  <Icon name="quote-start" />
                  {homeowner.pullQuote && homeowner.pullQuote[0].text}
                  <Icon name="quote-end" />
                </blockquote>
                <Link to={quotes[key].uri || ''} title="Read Story">
                  Read {homeowner.homeownerName}'s Story
                </Link>
              </div>
            </Container>
          );
        })}
      </Container>
    </Paper>
  );
};

export default TwoHomeownerQuotesBlock;
